import PublicLayout from '../PublicLayout';

const MasterLayout = () => (
  <PublicLayout surface="conversion" footerVariant="full" showFooterCta={false} />
);

export default MasterLayout;
